import { Button, TextField } from '@mui/material';
import React from 'react';
import Loading from '../../components/Loading';
import { Stack } from '@mui/system';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import { useCreateRecurringBonusMutation, useDeleteRecurringBonusMutation, useUpdateRecurringBonusMutation } from '../../features/model/recurringbonusSlice';

const AddRecurringBonusCard = ({person}) => {
    const [addObject, {isLoadingUpdate: isUpdating}] = useCreateRecurringBonusMutation();

    if (isUpdating) {
        return <Loading />
    }

    function onAddNew() {
        // you'll need to supply the minimum defaults here
        //console.log(person)
        addObject({person: person.id})
    }

    return <Stack sx={{margin: 2}} spacing={2}>
        <Button variant='contained' onClick={onAddNew}>Add Recurring Bonus</Button>
        {/* <TextField
              sx={{marginTop: 2}}
              placeholder='Type and press enter...'
              onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onAddNew(e.target.value);
                    e.target.value = "";
                  }
              }}
          /> */}
    </Stack>;
}

const RecurringBonusCard = ({object}) => {
    const [updateObject, {isLoadingUpdate: isUpdating }] = useUpdateRecurringBonusMutation();
    const [deleteObject] = useDeleteRecurringBonusMutation();

    if ( isUpdating) {
      return <Loading />;
    }
    return <Stack sx={{margin: 2}} spacing={2} direction={"row"}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker label="Start date" defaultValue={dayjs.utc(object.start_date).local()} onChange={(newValue) => {
                    updateObject({recurringbonus_id: object.id, data: {start_date: dayjs(newValue).utc()}});
                }} />
                <DatePicker label="End date" defaultValue={dayjs.utc(object.end_date).local()} onChange={(newValue) => {
                    updateObject({recurringbonus_id: object.id, data: {end_date: dayjs(newValue).utc()}});
                }} />
            </LocalizationProvider>
            <TextField label="Amount" type="float" defaultValue={object.amount} sx={{width: 200}} onChange={(event) => {
                updateObject({recurringbonus_id: object.id, data: {amount: event.target.value}});
            }} />
            <TextField label="USO Rate" type="float" defaultValue={object.uso_rate} sx={{width: 400}} onChange={(event) => {
                updateObject({recurringbonus_id: object.id, data: {uso_rate: event.target.value}});
            }} />
            <TextField label="Type" defaultValue={object.type} sx={{width: 400}} onChange={(event) => {
                updateObject({recurringbonus_id: object.id, data: {type: event.target.value}});
            }} />
            <Button variant={"outlined"} onClick={() => {
                deleteObject(object.id)
              }
            }>Delete</Button>
        </Stack>;
}
// start_date = DateTimeField(default=datetime.now)
//     end_date = DateTimeField(null=True)
//     amount = FloatField(default=0.0)
//     uso_rate = FloatField(default=0.0)
//     type = CharField(default="monthly")
export { RecurringBonusCard, AddRecurringBonusCard };